"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBgStyle = getBgStyle;
var _color = _interopRequireDefault(require("color"));
var _cccisdColorPicker = require("cccisd-color-picker");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function getBgStyle(settings, isShowingLayoutBgColor) {
  var color1 = (0, _color["default"])((0, _cccisdColorPicker.getColor)(settings.color)).lighten(0.3);
  var color2 = (0, _color["default"])((0, _cccisdColorPicker.getColor)(settings.color)).hex();
  if (settings.isColorLightened !== false) {
    color1 = (0, _color["default"])((0, _cccisdColorPicker.getColor)(settings.color)).lightness(98);
    color2 = (0, _color["default"])((0, _cccisdColorPicker.getColor)(settings.color)).lightness(95);
  }
  return {
    background: isShowingLayoutBgColor ? "radial-gradient(ellipse, ".concat(color1, " 40%, ").concat(color2, " 100%)") : "rgb(255, 255, 255)"
  };
}